// extracted by mini-css-extract-plugin
export default {"userInfoWrapper":"styles_userInfoWrapper__Srdhm","name":"styles_name__ljkOa","avatar":"styles_avatar__2jmaM","controlsOptionBtn":"styles_controlsOptionBtn__vQklf"};